import { render, staticRenderFns } from "./ProcessingTimeTranslationNewPopup.vue?vue&type=template&id=93f5ef3a&"
import script from "./ProcessingTimeTranslationNewPopup.vue?vue&type=script&lang=js&"
export * from "./ProcessingTimeTranslationNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports